var draw = SVG('drawing').size(1075, 590);
var cpt = 0;
var mapOrigin = {
    "lat": 50.472345,
    "lon": 4.819453
}
var scale = 2.8;
var xoffset = -750;
var yoffset = 20;
var areasLayer = draw.group();
var buildingsLayer = draw.group();
var highwaysLayer = draw.group();
var eschool = draw.group();

var xhr = new XMLHttpRequest();
xhr.overrideMimeType("application/json");
xhr.addEventListener("load", transferComplete);
xhr.open('GET', 'json-Indent.json');
xhr.send(null);

let kotPositions = [];
let kotId = [];
let kotIdInfo = [];
let kotPrice = [];



let url = 'https://www.student.be/fr/student-room-markers.json?city_or_address=namur';
fetch(url).then(response => response.json())
    .then((data) => {

        let kotinfo = data.student_room_markers;
        kotinfo.forEach(function (elem) {
            kotPositions.push([elem.longitude, elem.latitude]);
            kotId.push([elem.id]);
            kotPrice.push([elem.total_price]);
        });


        function getValeurs() {
            deleteKot();
            var parent = this.parentNode;
            var slides = parent.getElementsByTagName("input");
            var slide1 = parseFloat(slides[0].value);
            var slide2 = parseFloat(slides[1].value);



            var sliderMain = document.querySelector(".range-slider");
            sliderMain.setAttribute("slider-value-base", slide1);
            sliderMain.setAttribute("slider-value-end", slide2);

            kotPrice.forEach(function (elem, index) {
                if ((slide1 < elem) && (slide2 > elem)) {
                    drawOneKot(kotId[index], kotPositions[index], "kot", eschool);
                }
            });

            if (slide1 > slide2) {
                var tmp = slide2;
                slide2 = slide1;
                slide1 = tmp;
            }

            var displayElement = parent.getElementsByClassName("rangeValues")[0];
            displayElement.innerHTML = slide1 + "€" + " - " + slide2 + "€";


        }

        //drawKots(kotId, kotPositions, "kot", eschool);



        var sliderSections = document.getElementsByClassName("range-slider");

        for (var x = 0; x < sliderSections.length; x++) {
            var sliders = sliderSections[x].getElementsByTagName("input");
            for (var y = 0; y < sliders.length; y++) {
                if (sliders[y].type === "range") {
                    sliders[y].oninput = getValeurs;

                    sliders[y].oninput();
                }
            }
        }


        for (i = 0; i < kotinfo.length; i++) {

            const listekotli = document.createElement('li');
            const listekot = document.querySelector('.liste__kot');

            listekotli.innerHTML = `

                <div id="popup+${kotinfo[i].id}" class="overlay" data_id="${kotinfo[i].id}">
                    <div class="popup">
                            <img src="${kotinfo[i].first_image_url}" alt="Poster de ${kotinfo[i].title}"/>
                        <div class="content">

                         <h2>${kotinfo[i].title}</h2>
                            <a class="close" href="#map">&times;</a>
                            <div class="prix">${kotinfo[i].total_price} €</div>
                            <div><strong>Louer ce kot: </strong><br><a target="_blank" href="https://www.student.be/${kotinfo[i].show_url}">Lien vers Student.be</a><br><br></div>
                            <div><strong>Adresse: </strong><br><a target="_blank" href="https://www.google.be/maps/place/${kotinfo[i].latitude},${kotinfo[i].longitude}" target="_blank">Lien vers Google Map</a></div>
                        </div>
                    </div>
                </div>

              `;
            listekot.appendChild(listekotli);
        }
    });


function transferComplete(e) {

    try {
        data = JSON.parse(e.target.responseText);
        var nodecpt = 0;
        for (var i = 0; i < data.highways.length; i++) {
            var way = data.highways[i];
            drawHighway(way);
            nodecpt = nodecpt + way.nodes.length;
        }

        var nodecpt = 0;
        for (var i = 0; i < data.buildings.length; i++) {
            var building = data.buildings[i];
            drawBuilding(building);
            nodecpt = nodecpt + way.nodes.length;
        }

        var nodecpt = 0;
        for (var i = 0; i < data.school.length; i++) {
            var ecole = data.school[i];
            data.school[i].isActive = true;
            drawschool(ecole);
            nodecpt = nodecpt + way.nodes.length;
        }

    } catch (e) {
        console.error("Parsing error:", e);
    }

}

function drawschool(ecole) {
    drawSchool(ecole, "ecole", eschool);
}

function drawHighway(way) {
    var points = [];

    for (var j = 0; j < way.nodes.length; j++) {

        var converter = new UtmConverter();
        var rootutmResult = converter.toUtm({
            coord: [mapOrigin.lon, mapOrigin.lat]
        });
        var startutmResult = converter.toUtm({
            coord: [way.nodes[j].lon, way.nodes[j].lat]
        });

        var ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
        ax += xoffset;
        var ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
        ay += yoffset;
        points.push([ax, ay]);
    }

    var polyline = highwaysLayer.polyline(points);
    polyline.attr("class", "highway highway__" + way.category + " " + "highway__" + way.category + "--" + way.subcategory);
}

function drawArea(shape) {
    drawShape(shape, "area", areasLayer);
}

function drawBuilding(shape) {
    drawShape(shape, "building", buildingsLayer);
}

function drawShape(shape, baseclass, eschool) {
    var points = [];
    for (var j = 0; j < shape.nodes.length; j++) {

        var converter = new UtmConverter();
        var rootutmResult = converter.toUtm({
            coord: [mapOrigin.lon, mapOrigin.lat]
        });
        var startutmResult = converter.toUtm({
            coord: [shape.nodes[j].lon, shape.nodes[j].lat]
        });

        var ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
        ax += xoffset;
        var ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
        ay += yoffset;
        points.push([ax, ay]);
    }

    var polyline = eschool.polygon(points);
    polyline.attr("class", baseclass + " " + baseclass + "__" + shape.category + " " + baseclass + "__" + shape.category + "--" + shape.subcategory);
}


function toRadians(degAngle) {
    return degAngle * (Math.PI / 180);
}

var mapOrigin = {
    "lat": 50.472345,
    "lon": 4.819453
}
const earthRadius = 6371.009;
const svgScale = 1000;



function drawSchool(ecole, baseclass, eschool) {

    var points = [];
    for (var j = 0; j < ecole.nodes.length; j++) {

        var converter = new UtmConverter();
        var rootutmResult = converter.toUtm({
            coord: [mapOrigin.lon, mapOrigin.lat]
        });
        var startutmResult = converter.toUtm({
            coord: [ecole.nodes[j].lon, ecole.nodes[j].lat]
        });

        var ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
        ax += xoffset;
        var ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
        ay += yoffset;
        points.push([ax, ay]);

    }


    var polyline = eschool.circle(30).move(ax, ay);
    polyline.attr("class", baseclass + "__" + ecole.id);
    polyline.attr("id", baseclass + "__" + ecole.id);

    var gamesPicto = eschool.image("assets/images/grey.svg").size(35, 35).move(ax, ay);
    gamesPicto.attr("class", baseclass + " " + baseclass + "--" + ecole.id);
    gamesPicto.attr("id", ecole.id);

    var gamesPicto1 = eschool.image("assets/images/ecole.svg").size(40, 40).move(ax, ay);
    gamesPicto1.attr("class", baseclass + " " + baseclass + "__" + ecole.id);
    gamesPicto1.attr("id", ecole.id);
}


function drawKots(kotId, kotCoord, baseclass, eschool) {

    for (var j = 0; j < kotCoord.length; j++) {

        var converter = new UtmConverter();
        var rootutmResult = converter.toUtm({
            coord: [mapOrigin.lon, mapOrigin.lat]
        });
        var startutmResult = converter.toUtm({
            coord: kotCoord[j]
        });

        var ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
        ax += xoffset;
        var ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
        ay += yoffset;

        var gamesPicto = eschool.image("./assets/images/kot.svg").size(40, 40).move(ax, ay).attr("data-id", kotId[j][0]);
        gamesPicto.attr("class", baseclass);

    }

    const kots = document.querySelectorAll(".kot");
    for (let kot of kots) {
        kot.addEventListener('click', function (e) {
            console.log(e.srcElement.dataset.id);
            location.href = ("#popup+" + e.srcElement.dataset.id);
        });
    }
}


function drawOneKot(kotIdInfo, kotCoord, baseclass, eschool) {

    var converter = new UtmConverter();
    var rootutmResult = converter.toUtm({
        coord: [mapOrigin.lon, mapOrigin.lat]
    });
    var startutmResult = converter.toUtm({
        coord: kotCoord
    });

    var ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
    ax += xoffset;
    var ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
    ay += yoffset;

    var gamesPicto = eschool.image("assets/images/kot.svg").size(40, 40).move(ax, ay).attr("data-id", kotIdInfo[0]);
    gamesPicto.attr("class", baseclass);


    const kots = document.querySelectorAll(".kot");
    for (let kot of kots) {
        kot.addEventListener('click', function (e) {
            location.href = ("#popup+" + e.srcElement.dataset.id);
        });
    }
}



function deleteKot() {

    var kots = document.querySelectorAll(".kot");
    for (let kot of kots) {
        kot.remove();
    }
}



const links = document.querySelectorAll('.school__el a');

links.forEach((element) => {
    element.addEventListener('click', function (e) {
        const clickedLink = e.currentTarget;
        let attributePage = clickedLink.getAttribute('href');
        attributePage = attributePage.slice(1);
        document.body.setAttribute('data-section', attributePage);
    });
});



function setStyleOn(rule, targetId, value) {
    x = document.getElementById(targetId);
    x.style[rule] = value;
}

var slider1 = document.getElementById("myRange1");
var slider2 = document.getElementById("myRange2");
var slider3 = document.getElementById("myRange3");
var slider4 = document.getElementById("myRange4");
var slider5 = document.getElementById("myRange5");
var slider6 = document.getElementById("myRange6");

var output1 = document.querySelector("#demo1");
var output2 = document.querySelector("#demo2");
var output3 = document.querySelector("#demo3");
var output4 = document.querySelector("#demo4");
var output5 = document.querySelector("#demo5");
var output6 = document.querySelector("#demo6");
output1.innerHTML = slider1.value + "m.";
output2.innerHTML = slider2.value + "m.";
output3.innerHTML = slider3.value + "m.";
output4.innerHTML = slider4.value + "m.";
output5.innerHTML = slider5.value + "m.";
output6.innerHTML = slider6.value + "m.";

slider1.oninput = function (setStyleOn) {
    output1.innerHTML = this.value + "m.";
}

slider2.oninput = function (setStyleOn) {
    output2.innerHTML = this.value + "m.";
}

slider3.oninput = function (setStyleOn) {
    output3.innerHTML = this.value + "m.";
}

slider4.oninput = function (setStyleOn) {
    output4.innerHTML = this.value + "m.";
}

slider5.oninput = function (setStyleOn) {
    output5.innerHTML = this.value + "m.";
}

slider6.oninput = function (setStyleOn) {
    output6.innerHTML = this.value + "m.";
}

var infoEcole = document.querySelectorAll(".info__ecole");
var infos = document.querySelectorAll(".info__school");
for (var i = 0; i < infos.length; i++) {
    infos[i].addEventListener("click", (e) => {
        for (var i = 0; i < infos.length; i++) {
            infoEcole[i].classList.toggle("info__ecole--on");
            infos[i].classList.toggle("info__school--expended");
        }
    });
}

// Menu
var burger = document.querySelector(".menu__button");
var menu = document.querySelector(".menu");
var link = document.querySelectorAll(".menu__el");
var bgOverlay = document.querySelector(".overlay-bg");
var burgerEl = document.querySelectorAll(".button__el");

burger.addEventListener("click", (e) => {
    menu.classList.toggle("menu--toggle");
    bgOverlay.classList.toggle("overlay-bg--on");
    for (var i = 0; i < burgerEl.length; i++) {
        burgerEl[i].classList.toggle("button__el--open");
    }
});

for (var i = 0; i < link.length; i++) {
    link[i].addEventListener("click", (e) => {
        menu.classList.toggle("menu--toggle");
        bgOverlay.classList.remove("overlay-bg--on");
        for (var i = 0; i < burgerEl.length; i++) {
            burgerEl[i].classList.remove("button__el--open");
        }
    });
}
